import { Grid, Paper } from '@mui/material';
import { useSnackbar } from 'notistack';
import { SubmitHandler } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router';
import * as api from '../../api/app/opcClientApi';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { PageHeader } from '../../components/core/PageHeader/PageHeader';
import { useTranslation } from '../../contexts/translation';
import { OpcClientInputs } from '../../types/app/opcClient.types';
import { convertDataFromInputToCreateRequest } from '../../utils/core/functions/opcClient.functions';
import { paths } from '../../utils/core/routes';
import { OpcClientForm } from './OpcClientForm';
import { useStyles } from './OpcClientForm.styles';

export function OpcClientCreate() {
  const { t } = useTranslation();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { mutate: mutateCreateOpcClient } = useMutation(api.createOpcClient);

  const handleOnSubmit: SubmitHandler<OpcClientInputs> = (data: OpcClientInputs) => {
    const requestData = convertDataFromInputToCreateRequest({
      ...data,
    });

    mutateCreateOpcClient(
      { ...requestData },
      {
        onSuccess: () => {
          enqueueSnackbar(t('page.opc-client.item-created'), { variant: 'success' });
          navigate(paths.OPCCLIENT_LIST);
        },
        onError: (result: any) => {
          enqueueSnackbar(`${result}`, { variant: 'error' });
        },
      },
    );
  };

  return (
    <>
      <PageHeader title={t('page.opc-client.headline-create')} />
      <PageContent>
        <Grid container spacing={1}>
          <Grid item xs={12} md={8} lg={4}>
            <Paper className={classes.paper}>
              <OpcClientForm
                onSubmit={handleOnSubmit}
                onBack={() => navigate(paths.OPCCLIENT_LIST)}
              />
            </Paper>
          </Grid>
        </Grid>
      </PageContent>
    </>
  );
}
